<!-- selectable amounts -->
<div class="selectable-amounts-container">
    <button *ngFor="let item of selectableAmounts;" (click)="onAmountSelection(item)"
        mat-raised-button [color]="item?.isSelected ? 'accent' : ''">
        {{ item?.amount | number }} ریال
    </button>
</div>

<br>

<!-- charge amount form -->
<form [formGroup]="form" (ngSubmit)="onSubmit()">
    <mat-form-field>
        <mat-label>مبلغ شارژ</mat-label>
        <input maxlength="11" appNumericOnly appAutoFocus dir="ltr" class="text-center" matInput
            formControlName="amount" type="text"
            [value]="form.controls['amount'].value | customNumber">
        <span matSuffix dir="ltr">ریال</span>
        <mat-hint>حداقل مبلغ شارژ 50,000 ریال است</mat-hint>
        <mat-error *ngIf="form.controls['amount'].hasError('required')">
            مبلغ شارژ نمی‌تواند خالی باشد
        </mat-error>

        <mat-error *ngIf="form.controls['amount'].hasError('min')">
            حداقل مبلغ {{minAmount | number}} ریال است
        </mat-error>

        <mat-error *ngIf="form.controls['amount'].hasError('max')">
            حداکثر مبلغ {{maxAmount | number}} ریال است
        </mat-error>
    </mat-form-field>

    <div class="text-center">
        <button mat-raised-button color="primary" [disabled]="form.invalid || isSubmitting">
            انتقال به درگاه بانکی
        </button>
    </div>
</form>